import React from "react";
import "./NewsLetter.css";

const NewsLetter = () => {
  return (
    <div className="NewsLetter">
      <h2>Join us on email for</h2>
      <p>more trending topics</p>
      <button>Join Now</button>
    </div>
  );
};

export default NewsLetter;
